import { apiClient } from "helpers/api_helper";

export const getSalesOrderForReturnBySearch = async (params?: any) => {
    try {
        // const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetSalesOrderForReturnBySearch?invoiceNo=${params?.InvoiceSearch}`);
        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetSalesInvoiceForReturn?invoiceNo=${params}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllReturnSalesListData = async (params?: any) => {
    try {

        const response = await apiClient.get(`/api/v1/ReturnSalesOrder/GetAllReturnSalesOrdersList?searchText=${params}`)
        return response;
    } catch (error: any) {
        throw new Error(error.massage);
    }
};


export const getReturnData = async (data: any) => {
    try {
        const response = await apiClient.post('/api/v1/ReturnSalesOrder/CalculateBuyBackSalesOrderPrices', data)
        return response;
    } catch (error: any) {
        throw new Error(error.massage);
    }
}

export const HandleReturnData = async (data: any) => {
    try {
        const response = await apiClient.post('/api/v1/ReturnSalesOrder/InsertBuyBackOrReturnSaleOrder', data)
        return response;
    } catch (error: any) {
        throw new Error(error.massage);
    }
}

export const GetPaymentType = async () => {
    try {
        const response = await apiClient.get('api/v1/Payment/GetPaymentTypeSelectList')
        return response
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
}

export const ConfirmReturn = async (data: any) => {
    try {
        const response = await apiClient.post('api/v1/ReturnSalesOrder/InsertBuyBackOrReturnSaleOrder', data)
        return response
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
}

export const BuyBackReturnToFranchise = async (data: any) => {
    try {
        const response = await apiClient.post('api/v1/ReturnSalesOrder/InsertBuyBackOrReturnSaleOrder', data)
        return response
    } catch (error: any) {
        const message =
            error?.response?.data?.message || error?.message || "Unknown error occurred";
        throw new Error(message);
    }
}

export const InsertCustomerBankDetails = async (data: any) => {
    try {
        const response = await apiClient.post('api/v1/CustomerBankDetail/InsertCustomerBankDetails', data)
        return response
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const GetCustomerBankDetailByCustomerIdId = async (customerId: any) => {
    try {
        const response = await apiClient.get('api/v1/CustomerBankDetail/GetCustomerBankDetailsByCustomerId', { customerId })
        return response
    } catch (error: any) {
        throw new Error(error.message);
    }
}

export const DeleteCustomerBankDetails = async (id: any) => {
    try {
        const response = await apiClient.delete('api/v1/CustomerBankDetail/DeleteCustomerBankDetails?id=' + id);
        return response
    } catch (error: any) {
        throw new Error(error.message);
    }
}